import gql from 'graphql-tag';

export const MiniArticleCardFragment = gql`
  fragment MiniArticleCardFragment on ArticleCollection {
    items {
      sys {
        id
      }
      title
      slug
      # An article could have 2 categories. One parent and one child
      categoriesCollection(limit: 2) {
        items {
          title
          parentCategory {
            title
          }
          linkedFrom {
            categoryAssemblyCollection(limit: 1) {
              items {
                slug
                category {
                  title
                }
              }
            }
          }
        }
      }
      primaryImage {
        describedImage
        maxWidth
        image {
          title
          url
        }
      }
    }
  }
`;
